import React from "react";
import { myUtilities } from "../../Utils";

export default function MarketingText({ textId, defaultMessage }) {
  return (
    <div className="marketing-text-div">
      <h2>
        {myUtilities.accountSpecificLanguage(textId ,defaultMessage)}
      </h2>
    </div>
  );
}
